export const VERSUS_SCENARIOS = [
  // Tests of Skill & Prowess
  "Who would win a high-stakes game of laser tag?",
  "Who could more successfully perform a magic trick for a skeptical audience of children?",
  "Who is better at assembling IKEA furniture without the instructions?",
  "Who would win a city-wide parkour race?",
  "Who could choreograph and win an interpretive dance competition?",
  "Who would last longer in a sensory deprivation tank?",
  "Who is the superior street magician?",
  "Who could build the most impressive sandcastle in one hour?",
  "Who could win a game of Twister on a moving train?",
  "Who would win a professional hot dog eating contest?",
  "Who could paint the most convincing forgery of the Mona Lisa?",
  "Who would be the better professional wrestler (including persona and entrance)?",
  "Who could win a game of hide-and-seek in an open field?",
  "Who is better at calming down a swarm of angry bees?",
  "Who could win a bar fight using only improvised weapons?",
  "Who could teach a cat to play the piano?",
  "Who would be the superior air-guitar soloist?",
  "Who could land a commercial airliner with only radio instructions from a drunk pilot?",
  "Who is better at parallel parking a monster truck?",
  "Who could create the most delicious meal using only ingredients from a gas station?",
  "Who would win a thumb war to the death?",
  "Who could design and build the most effective Rube Goldberg machine?",
  "Who could win a staring contest against a statue?",
  
  // Social & Cunning Challenges
  "Who could more successfully talk their way out of a speeding ticket?",
  "Who could deliver the most awkward best man/maid of honor speech (and still get applause)?",
  "Who would be the first one voted off a reality TV show?",
  "Who could more successfully sell a haunted car at a used car lot?",
  "Who would be the better cult leader?",
  "Who could convince a flat-earther that the world is round?",
  "Who could host the most disastrously awkward dinner party?",
  "Who is better at comforting someone who is crying for a completely irrational reason?",
  "Who could win an argument against three angry grandmothers?",
  "Who could more successfully return an item to a store without a receipt?",
  "Who could get the most 'likes' on a terrible social media post?",
  "Who could successfully request a refund for a half-eaten sandwich?",
  "Who would be the more convincing fake psychic?",
  "Who could keep a secret the longest under intense interrogation?",
  "Who could successfully infiltrate a high school reunion without anyone noticing they didn't go there?",
  "Who is better at giving a completely nonsensical but inspiring motivational speech?",
  "Who could win a political debate by only using playground insults?",
  "Who could more successfully bargain with a dragon over the price of its treasure?",
  "Who would be better at faking their own death?",
  "Who could more effectively spread a ridiculous rumor throughout a small town?",
  "Who could win a game of charades while their hands are tied behind their back?",
  "Who is better at pretending to understand a complex wine tasting?",
  
  // Heists, Capers & "Professional" Jobs
  "Who could steal the Declaration of Independence?",
  "Who is better suited to capture a mythical creature (like Bigfoot or the Loch Ness Monster)?",
  "Who could successfully pet-sit a dragon for a long weekend?",
  "Who would make a better (or worse) getaway driver?",
  "Who could successfully sneak snacks into a high-security movie theater?",
  "Who could break out of an inescapable maximum-security prison?",
  "Who could lead a successful heist on the world's largest cheese vault?",
  "Who would be the better grizzled, old-school private investigator?",
  "Who could 'babysit' a super-villain's doomsday device for an afternoon?",
  "Who could successfully rob a bank using only a banana?",
  "Who could lead a mutiny on a pirate ship?",
  "Who would be the better secret agent (codename: Agent Buttercup)?",
  "Who could more successfully disarm a bomb by just randomly cutting wires?",
  "Who could replace the Queen's Corgis with well-disguised squirrels?",
  "Who could steal the secret formula for Krabby Patties?",
  "Who could lead an expedition to find the lost city of Atlantis?",
  "Who would make a better evil genius's henchman?",
  "Who could successfully perform corporate espionage at a clown college?",
  "Who could organize the most chaotic jailbreak?",
  "Who could replace all the golf balls at a country club with eggs right before a major tournament?",
  "Who could successfully capture a ghost?",
  
  // Endurance & Absurdity
  "Who could survive a 24-hour marathon of the worst movies ever made?",
  "Who would be the last one standing in a dance marathon?",
  "Who could best navigate a crowded shopping mall on Black Friday?",
  "Who would win in a grocery cart demolition derby?",
  "Who is more likely to survive a zombie apocalypse (but only for the first 72 hours)?",
  "Who would be the first to break during an intense staring contest?",
  "Who could survive being the main character in a romantic comedy?",
  "Who could win a race while riding an angry ostrich?",
  "Who could best lead an army of angry squirrels?",
  "Who would be the first to befriend (or be eaten by) an alien that just landed?",
  "Who could survive a conversation with the world's most boring person?",
  "Who could win a pillow fight against a sleep-deprived grizzly bear?",
  "Who would last longer in a room with a single, constantly dripping faucet?",
  "Who is better suited to live in a house made entirely of gelatin?",
  "Who could win a footrace through a field of Legos?",
  "Who would be the last person eaten by a dinosaur in a theme park disaster?",
  "Who could listen to the 'It's a Small World' song on a loop for the longest?",
  "Who could win a marathon that is entirely uphill, both ways, in the snow?",
  "Who could wear a wet wool sweater in the desert the longest without complaining?",
  "Who could survive a battle against an army of 100 duck-sized horses?",
  "Who could survive a battle against one horse-sized duck?"
];

export const VERSUS_TOOLS = [
  // Mundane & Everyday
  "A Single Rubber Band",
  "A Spork",
  "A Slightly-Sticky Lollipop",
  "One (1) Sock (Slightly Damp)",
  "A Ballpoint Pen That's Almost Out of Ink",
  "A Stack of Post-it Notes",
  "A Roll of Duct Tape",
  "A Leaf Blower",
  "A Squeaky Rubber Chicken",
  "Half a Coconut",
  "A Can of Beans (Unopened, No Can Opener)",
  "A Stapler (with 3 Staples Left)",
  "A Single, Uncooked Noodle",
  "A Jar of Pickles",
  "An Overly-Ripe Banana",
  "A Fold-Up Chair",
  "A Garden Gnome",
  "A Caffeinated Gerbil",
  "A Single AAA Battery",
  "A Floppy Disk with an Unknown Program",
  "A Used Tea Bag",
  "A Plastic Flamingo",
  "A Dusty Trombone",
  "A Pair of Fuzzy Dice",
  
  // Upgraded & Oddly Specific
  "A Swiss Army Knife (but all the tools are spoons)",
  "A Grappling Hook That Only Attaches to Cheese",
  "Anti-Gravity Boots (but only one works)",
  "A Laser Pointer (that actually works like a laser)",
  "A Never-Ending Bag of Popcorn",
  "A Skateboard with Rocket Boosters",
  "Goggles That Let You See 5 Seconds into the Future",
  "A T-Shirt Cannon (that only shoots confetti)",
  "A Bubble Gun That Shoots Acidic Bubbles",
  "A Flamethrower That Only Shoots Cold Water",
  "A Cloak of Invisibility (but it's bright neon orange)",
  "A Boomerang That Always Returns... Eventually",
  "A Refrigerator That Generates a Random Condiment Once a Day",
  "A Toaster That Toasts Pictures onto Bread",
  "A Glider That's a Bit Afraid of Heights",
  "A Pair of Binoculars That Only Work Backwards",
  "A Boxing Glove on a Spring",
  "A Helmet That Translates Your Thoughts into Opera",
  "A Pogo Stick with Turbo-Boost",
  "A Yo-Yo Made of Unobtanium",
  "An Umbrella That Makes it Rain (only on you)",
  "A Guitar That Only Plays the Brown Note",
  
  // Technological & Fantastical
  "A Sassy, Malfunctioning Robot Sidekick",
  "A Portable Black Hole (about the size of a golf ball)",
  "One (1) Wish (but it's interpreted by a mischievous genie)",
  "A Time Machine (that only goes forward 1 second at a time)",
  "A Clumsy Mecha-Suit",
  "A Shrink Ray (that is stuck on 'enlarge')",
  "The Ability to Speak to Squirrels",
  "A Jetpack Fueled by Soda and Mentos",
  "A Clone of Yourself (that actively dislikes you)",
  "A Magic Wand (that only knows one spell: 'Summon Hamster')",
  "A Sentient, Grumpy Potted Plant",
  "A Portal Gun (but you don't know where the portals go)",
  "A Sword That Screams Whenever It's Swung",
  "A Bag of Holding (that is actually just a regular, small bag)",
  "A Potion of Invincibility (that lasts for 3 seconds)",
  "A Teleportation Device (that occasionally loses your luggage... or a limb)",
  "A Ring That Lets You Understand Insects (they mostly complain)",
  "A Sentient Cloud That Follows You Around and Criticizes Your Choices",
  "A Spellbook with All the Pages Stuck Together",
  "An Amulet of Mind Control (only works on garden slugs)",
  "A Cursed Monocle",
  "A Flying Carpet (that is extremely lazy)"
];